import { AccountNotification } from 'acscp/api/models/accountNotification';
import { createSelector } from 'reselect';
import { AppState } from '../appState';
import { AccountNotificationState } from '../accountNotificationState';

const accountNotificationsSelector = (state: AppState) => state.accountNotifications;

const getAccountNotificationsFromState = (accountNotifications: AccountNotificationState) => {
    const notifications: AccountNotification[] = [];
    for (const key of Object.keys(accountNotifications)) {
        notifications.push(accountNotifications[key]);
    }
    return notifications
        .sort((notification1, notification2) => notification2.createdAt.diff(notification1.createdAt));
};

export const getAccountNotifications = createSelector(
    accountNotificationsSelector,
    getAccountNotificationsFromState
);

export const getNumberOfUnreadNotifications = (state: AppState) => {
    return getAccountNotifications(state).filter(n => !n.hasBeenRead).length;
};
